import html2canvas from "html2canvas";
import moment from "moment";
import { jsPDF } from "jspdf";
import logo from "../../assets/images/logo.png";
import { paymentMethods } from "../../data";
import { formatNumberWithCommas, formattedDate } from "../../helpers";
import { convertUtcToLocalTime } from "../../helpers/exportHelpers";
const getStatusLabel = (statusId) => {
  switch (statusId) {
    case 1:
      return "Received";
    case 2:
      return "Refunded";
    default:
      return "--";
  }
};
// Safe date formatter function
const safeFormatDateTime = (date) => {
  const formattedDateString = convertUtcToLocalTime(date);
  try { 
    if (!formattedDateString) return "--";
    return formattedDate(formattedDateString) + "<br>" + moment(formattedDateString).format("hh:mm A");
  } catch (error) {
    console.error("Error formatting date/time:", error);
    return "--";
  }
};

export const exportPaymentListingToPDF = (payments) => {
  console.log("payments [] ==>", payments);
  
  // Create a style element for our CSS classes
  const styleElement = document.createElement("style");
  styleElement.textContent = `
      .pdf-container {
        width: 210mm;
        padding: 20px;
        font-family: Arial, sans-serif;
        position: absolute;
        left: -9999px;
      }
      .logo-section {
        text-align: center;
        margin-bottom: 20px;
      }
      .logo-image {
        width: 190px;
        height: 40px;
      }
      .reference-section {
        margin-bottom: 20px;
      }
      .reference-title {
        color: var(--highlight-text);
        font-size: 20px;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 14px;
        margin-top: 10px;
      }
      .details-section {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 840px;
        gap: 10px;
        margin-bottom: 20px;
        font-size: 12px;
      }
      .detail-list-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 10px;
        width: 200mm;
        box-sizing: border-box;
      }
      .detail-list-wrapper li {
        width: calc(50% - 10px);
        margin-bottom: 8px;
      }
      .detail-item {
        margin: 0;
        line-height: 20px;
        letter-spacing: -0.25px;
        display: flex;
        align-items: center;
        font-family: "NotoSans-semibold";
        font-size: 16px;
        margin-bottom: 10px;
      }
      .detail-item strong {
        color: var(--highlight-text);
        font-weight: 600;
        line-height: 20px;
        letter-spacing: -0.25px;
        font-family: "NotoSans-semibold";
        display: inline-block;
        min-width: 80px;
      }
      .detail-item span {
        color: var(--dusky-steel);
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.25px;
        font-family: "NotoSans-regular";
        display: inline-block;
        min-width: 80px;
      }
      .divider {
        border: none;
        border-top: 1px solid #ccc;
        margin: 20px 0;
      }
      .section-title {
        margin-top: 20px;
        font-size: 20px;
        font-weight: 600;
        color: var(--highlight-text);
        margin-bottom: 10px;
      }
      .data-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 9px;
        margin-bottom: 20px;
      }
      .table-header {
        background-color: transparent;
        color: var(--highlight-text);
        font-weight: 600;
        font-size: 14px;
      }
      thead .table-cell {
        padding: 8px;
        text-align: left;
        border-bottom: 1px solid #9EA2B3;
        border-top: 1px solid #9EA2B3;
        font-size: 14px;
        font-weight: 600;
        color: var(--highlight-text);
      }
      tbody .table-cell {
        padding: 8px;
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        color: var(--dusky-steel);
      }
      .empty-row {
        font-size: 16px;
        color: var(--dusky-steel);
        font-family: "NotoSans-semibold";
        text-align: center;
        padding: 8px;
      }
      .status-paid {
        color: #22c55e;
        background-color: #e6f7ed;
        padding: 4px 8px;
        border-radius: 4px;
        display: inline-block;
      }
      .status-unpaid {
        color: #ef4444;
        background-color: #fee2e2;
        padding: 4px 8px;
        border-radius: 4px;
        display: inline-block;
      }
      .summary-section {
        margin-top: 20px;
        border-top: 1px solid #9EA2B3;
        padding-top: 10px;
      }
      .total-amount {
        text-align: right;
        font-size: 16px;
        font-weight: 600;
        color: var(--highlight-text);
      }
    `;
  document.head.appendChild(styleElement);

  // Create an HTML container for our content
  const container = document.createElement("div");
  container.className = "pdf-container";
  document.body.appendChild(container);

  // Calculate total amount
  const totalAmount = payments.reduce((sum, payment) => sum + (payment?.amount || 0), 0);

  // Create HTML content with classes
  const content = `
      <div class="logo-section">
        <img class="logo-image" src="${logo}" alt="Logo">
      </div>
      
      <div>
        <h2 class="section-title">Payment Transactions</h2>
      </div>
      
      <div>
        <table class="data-table">
          <thead>
            <tr class="table-header">
              <th class="table-cell">Payment ID</th>
              <th class="table-cell">Booking ID</th>
              <th class="table-cell">Date & Time</th>
              <th class="table-cell">Name</th>
              <th class="table-cell">Court</th>
             
              <th class="table-cell">Payment Mode</th>
              <th class="table-cell">Amount</th>
              <th class="table-cell">Status</th>
            </tr>
          </thead>
    
          <tbody>
            ${
              payments && payments.length > 0
                ? payments.map(
                    (payment) => `
              <tr>
                <td class="table-cell">
                  ${payment?.payNo?.split("-")?.slice(1).join("-") || "--"}
                </td>
                <td class="table-cell">
                  ${payment?.bookingNo?.split("-")?.slice(1).join("-") || "--"}
                </td>
                <td class="table-cell">
                  ${safeFormatDateTime(payment?.paymentDate)}
                </td>
                <td class="table-cell">
                  ${payment?.userFullName || "--"}
                </td>
                <td class="table-cell">
                ${payment?.courtName || "--"}<br>${payment?.locationName || "--"}
                
                </td>
                <td class="table-cell">
                  ${
                    paymentMethods?.find(
                      (item) => item?.value === payment?.paymentModeId
                    )?.label || "--"
                  }
                </td>
                <td class="table-cell">
                  Rs. ${formatNumberWithCommas(payment?.amount || 0)}
                </td>
                <td class="table-cell">
                  <span>
                    ${ getStatusLabel(payment?.paymentStatusId)}
                  </span>
                </td>
              </tr>
            `
                  )
                  .join("")
                : `<tr><td class="empty-row" colspan="8">No payment transactions available</td></tr>`
            }
          </tbody>
        </table>
        
        <div class="summary-section">
          <div class="total-amount">
            Total Amount: Rs. ${formatNumberWithCommas(totalAmount)}
          </div>
        </div>
      </div>
    `;

  // Set the innerHTML of the container
  container.innerHTML = content;

  // Function to handle PDF generation after HTML is rendered
  const generatePDF = async () => {
    try {
      // Use html2canvas to convert the HTML to canvas
      const canvas = await html2canvas(container, {
        scale: 2, // Higher scale for better quality
        useCORS: true, // Enable CORS for images
        logging: false,
      });

      // Create PDF
      const pdf = new jsPDF("p", "mm", "a4");
      const imgData = canvas.toDataURL("image/png");

      // Calculate the proper scaling
      const imgWidth = 210; // A4 width in mm minus margins
      const pageHeight = 297; // A4 height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      // Add first page
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Add more pages if content is longer than one page
      while (heightLeft > 0) {
        position = -pageHeight * (imgHeight / heightLeft);
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      // Save the PDF with current date
      pdf.save(`payment_transactions_${moment().format("YYYY-MM-DD")}.pdf`);

      // Clean up
      document.body.removeChild(container);
      document.head.removeChild(styleElement);
    } catch (error) {
      console.error("Error generating PDF:", error);
      document.body.removeChild(container);
      document.head.removeChild(styleElement);
    }
  };

  // Generate the PDF
  generatePDF();
}; 